export const uk = {
    BYN: 'Белорусские рубли',
    CHF: 'Швейцарские франки',
    EUR: 'Евро',
    KZT: 'Казахстанские тенге',
    RUB: 'Российские рубли',
    TRY: 'Турецкие лиры',
    UAH: 'Украинские гривны',
    USD: 'Доллары США',
    UZS: 'Узбекские сумы',
    currency: 'Валюта',
    default: 'нет',
    from: 'от',
    prefix: 'Префикс',
    price: 'Цена',
    priceOld: 'Старая цена',
    to: 'до'
};
